import React from 'react';
import PropTypes from 'prop-types';

import { PhotographPropTypes } from 'dpl/shared/utils/customPropTypes';
import SmartImage from 'dpl/components/SmartImage';
import MediaCarouselSplide, {
  DEFAULT_SPLIDE_OPTIONS
} from 'dpl/common/components/MediaCarouselSplide';

export function BreedDescriptionCarouselImage({ image, smartImageProps }) {
  const { url, alt } = image;

  return (
    <div className="BreedDescriptionCarouselImage relative">
      <SmartImage {...smartImageProps} alt={alt} src={url} />
    </div>
  );
}

BreedDescriptionCarouselImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  smartImageProps: PropTypes.object.isRequired
};

function BreedDescriptionCarousel({ images, smartImageProps }) {
  return (
    <div
      className="BreedDescriptionCarousel"
      style={{
        minHeight: smartImageProps.height || '1px',
        minWidth: smartImageProps.width || '1px'
      }}
    >
      <MediaCarouselSplide
        splideClassName="BreedDescriptionCarousel__MediaCarouselSplide"
        mediaFiles={images}
        smartImageProps={smartImageProps}
        CarouselMediaComponent={BreedDescriptionCarouselImage}
        splideOptions={DEFAULT_SPLIDE_OPTIONS}
        hasPhotoBullets
        bulletStyle={{ transform: 'scale(0.85)', margin: '2px' }}
      />
    </div>
  );
}

BreedDescriptionCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      ...PhotographPropTypes
    })
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  smartImageProps: PropTypes.object.isRequired
};

export default BreedDescriptionCarousel;
